'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getArticleEmbeddedQuery = getArticleEmbeddedQuery;
function getArticleEmbeddedQuery() {
  var list = ['authorImages', 'og_image', 'tags', 'categories'];
  var query = {};
  list.forEach(function (ele) {
    query[ele] = 1;
  });
  return query;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/get-embedded-query-param.js
 ** module id = 844
 ** module chunks = 0
 **/